import React, { useState } from 'react';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { isMobile } from 'react-device-detect';

import { Tab } from '../../@types/State';
import useBuildingBookNames from '../../hooks/useBuildingBookNames';
import { useRecentIntel } from '../../hooks/useRecentIntel';
import IntelGridTabs from '../Intel/components/IntelGridTabs';
import ArmyGrid from '../Intel/gridViews/ArmyGrid';
import MainGrid from '../Intel/gridViews/MainGrid';

const Intel = () => {
  const [currentTab, setCurrentTab] = useState<Tab>('overview');
  const [bookNames, buildNames] = useBuildingBookNames();
  const recentData = useRecentIntel();

  const renderIntelGrid = () => {
    if (currentTab === 'armies') {
      return <ArmyGrid dataSet={recentData} />;
    }
    return (
      <MainGrid
        dataSet={recentData}
        plan={undefined}
        currentTab={currentTab}
        isViewingEnemy={true}
        hideTotals={true}
        isViewingRecent={true}
      />
    );
  };

  return (
    <div className='Home'>
      <Box mt={isMobile ? 0 : 2} className='Home'>
        <Box
          sx={{
            height: '50px',
            display: { xs: 'flex' },
            alignItems: 'center',
            marginX: 1,
          }}
        >
          <Typography variant='h2' component='span'>
            Recent Intel
          </Typography>
        </Box>

        <IntelGridTabs
          currentTab={currentTab}
          handleChangeTab={(e: any, newValue: any) => setCurrentTab(newValue)}
          hasBookNames={!!bookNames}
          hasBuildingNames={!!buildNames}
          isRecentView
        />

        <Box mx={1} mb={2} style={{ minHeight: 200 }}>
          <div style={{ width: '100%' }}>{renderIntelGrid()}</div>
        </Box>
      </Box>
    </div>
  );
};

export default Intel;
